/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import axios from "axios";
import { pathConstants } from "@/shared/pathConstants";
import store from "@/store";
import { helpers } from "@/shared/helper";
import Vue from "vue";
import moment from "moment/moment";

const persistSimulation = function(simulation) {
  return axios
    .post(`${pathConstants.API}/simulation`, simulation, { showLoader: false })
    .then(
      result => {
        if (result.data) {
          return result.data;
        } else {
          return {};
        }
      },
      err => {
        Vue.$log.error("persistSimulation", err);
      }
    );
};

const persistComplexSimulation = function(data) {
  return axios
    .post(
      `${pathConstants.API}/simulation/estimation/${data.simulationId}`,
      data.ficheAddress,
      {
        showLoader: false,
        params: {
          isImportInMass: data.isImportInMass
        }
      }
    )
    .then(
      result => {
        if (result.data) {
          store.commit("simulation/setOperations", result);
          return result.data;
        } else {
          return {};
        }
      },
      err => {
        Vue.$log.error("persistSimulation", err);
      }
    );
};
const saveComment = function(data) {
  console.log("in service ", data.comment);
  const headers = {
    "Content-Type": "text/plain"
  };
  return axios
    .post(`${pathConstants.API}/simulation/comment/${data.id}`, data.comment, {
      showLoader: false,
      headers
    })
    .then(
      result => {
        if (result.data) {
          return result.data;
        } else {
          return {};
        }
      },
      err => {
        Vue.$log.error("persistSimulation", err);
      }
    );
};

const fetchSimulations = function(
  currentPage,
  perPage,
  sortBy = null,
  sortDir = null,
  customFilter,
  search,
  tab = "all"
) {
  const pager = {
    page: currentPage > 1 ? currentPage - 1 : 0,
    size: perPage,
    defaultSort: sortBy,
    defaultOrder: sortDir
  };
  return axios
    .post(pathConstants.API + `/simulation/lookup?tab=${tab}`, {
      myPager: pager,
      customFilter: customFilter,
      search: search
    })
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("fetchSimulations", err);
      }
    );
};

const fetchSimulationsAdminAgence = function(
  currentPage,
  perPage,
  sortBy = null,
  sortDir = null,
  customFilter,
  search,
  agenceId,
  tab = "all"
) {
  const pager = {
    page: currentPage > 1 ? currentPage - 1 : 0,
    size: perPage,
    defaultSort: sortBy,
    defaultOrder: sortDir
  };
  return axios
    .post(pathConstants.API + `/simulation/agences/${agenceId}?tab=${tab}`, {
      myPager: pager,
      customFilter: customFilter,
      search: search
    })
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("fetchSimulations", err);
      }
    );
};

const fetchSimulationsChargeDeProjet = function(
  currentPage,
  perPage,
  sortBy = null,
  sortDir = null,
  customFilter,
  search,
  tab = "all"
) {
  const pager = {
    page: currentPage > 1 ? currentPage - 1 : 0,
    size: perPage,
    defaultSort: sortBy,
    defaultOrder: sortDir
  };
  return axios
    .post(pathConstants.API + `/simulation/chargeDeProjets?tab=${tab}`, {
      myPager: pager,
      customFilter: customFilter,
      search: search
    })
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("fetchSimulations", err);
      }
    );
};

const fetchSimulationsChargeDeProjetById = function(
  currentPage,
  perPage,
  sortBy = null,
  sortDir = null,
  customFilter,
  search,
  userId,
  tab = "all"
) {
  const pager = {
    page: currentPage > 1 ? currentPage - 1 : 0,
    size: perPage,
    defaultSort: sortBy,
    defaultOrder: sortDir
  };
  return axios
    .post(
      pathConstants.API + `/simulation/chargeDeProjets/${userId}?tab=${tab}`,
      {
        myPager: pager,
        customFilter: customFilter,
        search: search
      }
    )
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("fetchSimulations", err);
      }
    );
};

const validateOrLose = function(id, lose, reason = '', message = '') {
    const url = `${pathConstants.API}/simulation/validate/${id}/${lose}`;
    return axios
        .get(url, {
            params: {
                reason,
                message
            }
        })
        .then(
            result => {
                return result.data;
            },
            err => {
                Vue.$log.error("validateOrLoseSimulation", err);
            }
        );
};

const downloadSimulations = function(customFilter) {
  store.commit("loader/showDownloadWorksOrSimulations");
  axios({
    url: pathConstants.API + "/simulation/downloadSimulations",
    data: customFilter,
    method: "POST",
    responseType: "blob",
    showLoader: false
  })
    .then(response => {
      helpers.downloadFile(response);
    })
    .finally(() => store.commit("loader/hideDownloadWorksOrSimulations"));
};

const fetchCityByZipCode = function(zipCode) {
  return axios
    .get(pathConstants.API + `/address/city?zipCode=${zipCode}`, {
      showLoader: false
    })
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("getCityByZipCode", err);
      }
    );
};

const fetchFiches = function(applicationSector, type, operationBeginDate) {
  return axios
    .get(pathConstants.API + `/fiche/application-sector-and-types-and-date`, {
      params: { applicationSector, type, operationBeginDate },
      showLoader: false
    })
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("fetchFiches", err);
      }
    );
};

const fetchFicheById = function(id, zone) {
  return axios
    .get(pathConstants.API + `/fiche/${id}`, {
      params: { zone },
      showLoader: false
    })
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("fetch Fiche by id", err);
      }
    );
};

const fetchEstimationsBySimulationId = function(id) {
  return axios.get(pathConstants.API + `/simulation/estimations/${id}`).then(
    result => {
      return result.data;
    },
    err => {
      Vue.$log.error("fetch estimation by simulation id", err);
    }
  );
};

const fetchEstimationsByGlobalOperationId = function(id) {
  return axios
    .get(pathConstants.API + `/simulation/estimations/globalOperations/${id}`)
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("fetch estimation by simulation id", err);
      }
    );
};

const fetchSimulationCount = function() {
  return axios.get(pathConstants.API + `/simulation/count`).then(
    result => {
      return result.data;
    },
    err => {
      Vue.$log.error("fetch simulation count", err);
    }
  );
};

const fetchSimulationCountAdminAgence = function(agenceId) {
  return axios
    .get(pathConstants.API + `/simulation/count/agences/${agenceId}`)
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("fetch simulation count", err);
      }
    );
};

const fetchSimulationCountChargeDeProjet = function() {
  return axios
    .get(pathConstants.API + `/simulation/count/chargeDeProjets`)
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("fetch simulation count", err);
      }
    );
};

const fetchSimulationCommentById = function(id) {
  return axios.get(pathConstants.API + `/simulation/comment/${id}`).then(
    result => {
      return result.data;
    },
    err => {
      Vue.$log.error("fetch simulation comment", err);
    }
  );
};

const siretAttachedToCompany = function(siret) {
  return axios
    .get(pathConstants.API + `/simulation/siretAttachedToCompany/${siret}`)
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("Check if siret attached to the company", err);
      }
    );
};

const persistDatesSimulation = function(payload) {
  return axios
    .post(`${pathConstants.API}/simulation/dates/${payload.id}`, payload, {
      showLoader: false
    })
    .then(
      result => {
        if (result.data) {
          return result.data;
        } else {
          return {};
        }
      },
      err => {
        Vue.$log.error("persistDatesSimulation", err);
      }
    );
};

const getOperations = function(
  id,
  currentPage,
  perPage,
  sortBy,
  sortDir,
  customFilter,
  search
) {
  const pager = {
    page: currentPage > 1 ? currentPage - 1 : 0,
    size: perPage,
    defaultSort: sortBy,
    defaultOrder: sortDir === "desc"
  };
  return axios
    .post(`${pathConstants.API}/operations/by-simulation-id/${id}`, {
      myPager: pager,
      customFilter,
      search
    })
    .then(
      result => {
        if (result.data) {
          store.commit("simulation/setOperations", result.data);
          return result.data;
        }
        return [];
      },
      err => {
        Vue.$log.error("getOperations", err);
      }
    );
};

const getAssignOperations = function(
  id,
  currentPage,
  perPage,
  sortBy,
  sortDir,
  customFilter,
  search
) {
  const pager = {
    page: currentPage > 1 ? currentPage - 1 : 0,
    size: perPage,
    defaultSort: sortBy,
    defaultOrder: sortDir === "desc"
  };
  return axios
    .post(`${pathConstants.API}/operations/to-assign/by-simulation-id/${id}`, {
      myPager: pager,
      customFilter,
      search
    })
    .then(
      result => {
        if (result.data) {
          store.commit("simulation/setAssignOperations", result.data);
          return result.data;
        }
        return [];
      },
      err => {
        Vue.$log.error("getOperations", err);
      }
    );
};

const fetchSimulationOperation = function(idOperation) {
  return axios
    .get(
      `${pathConstants.API}/operations/referenceClient/simulation/${idOperation}`
    )
    .then(
      result => result.data,
      err => {
        Vue.$log.error("fetchSimulationOperation", err);
      }
    );
};

export const simulationService = {
  fetchSimulations,
  fetchSimulationsAdminAgence,
  fetchSimulationsChargeDeProjet,
  fetchSimulationsChargeDeProjetById,
  persistSimulation,
  persistComplexSimulation,
  validateOrLose,
  downloadSimulations,
  fetchCityByZipCode,
  fetchFiches,
  fetchFicheById,
  fetchEstimationsBySimulationId,
  fetchEstimationsByGlobalOperationId,
  fetchSimulationCount,
  fetchSimulationCountAdminAgence,
  fetchSimulationCountChargeDeProjet,
  siretAttachedToCompany,
  persistDatesSimulation,
  saveComment,
  fetchSimulationCommentById,
  getOperations,
  getAssignOperations,
  fetchSimulationOperation
};
